import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, IconButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { setMiniPlayerInLocalStorage } from "JS/Helpers/MiniPlayerHelper";
import { useMiniPlayer } from "JS/React/Hooks/MiniPlayer";
import { useState } from "react";
import { AppCircularProgress } from "../Progress/AppCircularProgress";

interface StyledIconButtonProps extends IconButtonProps {
    isMini?: boolean;
}

const StyledIconButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== "isMini",
})<StyledIconButtonProps>(({ isMini }) => ({
    ...(!isMini && {
        position: "absolute",
        top: 10,
        right: 10,
        background: "rgba(0,0,0,0.5) !important",
    }),
}));

const StyledIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: "1.1rem",
    color: theme.palette.common.black,
}));

export const RefreshButton = (props: RefreshButtonProps) => {
    const { isMini } = props;
    const { miniPlayer } = useMiniPlayer();
    const [isRefreshing, setIsRefreshing] = useState(false);

    const handleRefreshClick = () => {
        setIsRefreshing(true);
        if (miniPlayer && miniPlayer.url) {
            setMiniPlayerInLocalStorage(miniPlayer);
        }

        setTimeout(() => {
            window.location.reload();
        }, 1000);
    };

    return (
        <StyledIconButton onClick={handleRefreshClick} isMini={isMini}>
            {isRefreshing ? (
                <AppCircularProgress loaderSize="small" />
            ) : (
                <StyledIcon id="expand" icon={["fas", "rotate-right"]} />
            )}
        </StyledIconButton>
    );
};

export interface RefreshButtonProps extends IconButtonProps {
    isMini?: boolean;
}
